export default "__VITE_ASSET__Duy8WBvb__"